import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxFormComponent, DxPopupComponent } from 'devextreme-angular';
import { EventService } from 'src/app/services/event.service';
import { SessionContextService } from 'src/app/services/session-context.service';
import { CashUpInfo, TerminalService } from 'src/app/services/terminal.service';
import { Terminal } from '../../model/Terminal.model';
import { CloseTillDiscrepancyComponent } from '../close-till-discrepancy/close-till-discrepancy.component';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import * as dayjs from 'dayjs';
import { ConstantsService } from 'src/app/services/constants.service';

@Component({
  selector: 'app-close-till',
  templateUrl: './close-till.component.html',
  styleUrls: ['./close-till.component.css'],
})
export class CloseTillComponent implements OnInit, OnDestroy {
  @Output() CloseDlg: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild(DxPopupComponent) popup: DxPopupComponent;
  @ViewChild(CloseTillDiscrepancyComponent) dlgDiscrepancyReason: CloseTillDiscrepancyComponent;
  @ViewChild('cashUpInfoForm') cashUpInfoForm: DxFormComponent;
  @ViewChild('reportingPasswordForm') reportingPasswordForm: DxFormComponent;
  cashUpInfo: CashUpInfo = new CashUpInfo();
  terminal: Terminal = null;
  reportingPasswordDialogVisible = false;
  reportingPasswordFormData = { reportingPassword: '' };
  salesTransactionListDialogVisible = false;
  defaultDataChanged$: Subscription;
  cashUpDialogVisible: boolean = false;
  isCashUpFormValid: boolean = true;

  CheckTransactionsButtonOptions = {
    text: 'Check Transactions',
    onClick: this.btnCheckTransactions.bind(this),
    visible: false,
  };

  OkButtonOptions = {
    text: 'OK',
    onClick: this.btnOk.bind(this),
  };

  CancelButtonOptions = {
    text: 'Cancel',
    onClick: this.btnCancel.bind(this),
  };

  ReportingPasswordOkButtonOptions = {
    text: 'OK',
    onClick: this.reportingPasswordBtnOk.bind(this),
  };

  ReportingPasswordCancelButtonOptions = {
    text: 'Cancel',
    onClick: this.reportingPasswordBtnCancel.bind(this),
  };

  dateEditorOptions = {
    displayFormat: 'd MMM yyyy',
    useMaskBehavior: false,
    type: 'date',
    formatString: 'd MMM yyyy',
    invalidDateMessage: 'Value must be a valid date in the form of d MMM yyyy',
    placeHolder: 'd MMM yyyy',
  };

  timeEditorOptions = {
    displayFormat: 'HH:mm',
    useMaskBehavior: false,
    type: 'time',
    formatString: 'HH:mm',
    invalidDateMessage: 'Value must be a valid time in the form of HH:mm',
    placeHolder: 'HH:mm',
  };

  constructor(
    public constants: ConstantsService,
    private terminalService: TerminalService,
    private session: SessionContextService,
    private router: Router,
    private events: EventService
  ) {
    this.OnCloseDiscrepancyDlg = this.OnCloseDiscrepancyDlg.bind(this);
    this.OnCloseSalesTransactionListDlg = this.OnCloseSalesTransactionListDlg.bind(this);
    this.ProcessCloseTerminal = this.ProcessCloseTerminal.bind(this);
    this.validateStartDate = this.validateStartDate.bind(this);
    this.validateEndDate = this.validateEndDate.bind(this);
    this.validateStartTime = this.validateStartTime.bind(this);
    this.validateEndTime = this.validateEndTime.bind(this);

    this.defaultDataChanged$ = this.events.onDefaultDataChanged.subscribe((data) => {
      const toolbarItems = this.popup.instance.option('toolbarItems');
      const checkTransactionsButtonVisible: boolean =
        data.customerSettings.SetReportingPassword && data.customerSettings.ReportingPassword?.length > 0;

      toolbarItems.forEach((i) => {
        if (i.options?.text === 'Check Transactions') {
          i.options.visible = checkTransactionsButtonVisible;
        }
      });
      this.popup.instance.option('toolbarItems', toolbarItems);
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.defaultDataChanged$?.unsubscribe();
  }

  onContentReady(e: any) {
    const toolbarItems = this.popup.instance.option('toolbarItems');

    if (
      this.session.defaultData.defData.customerSettings.SetReportingPassword &&
      this.session.defaultData.defData.customerSettings.ReportingPassword?.length > 0
    ) {
      toolbarItems.forEach((i) => {
        if (i.options?.text === 'Check Transactions') {
          i.options.visible = true;
        }
      });
      this.popup.instance.option('toolbarItems', toolbarItems);
    }
  }

  public show() {
    this.terminal = this.session.GetSelectedTerminal();

    if (this.terminal.TillConnected == false) {
      return;
    }

    this.terminalService
      .IsTerminalOpen()
      .pipe(take(1))
      .subscribe((r) => {
        if (r == false) {
          return;
        }

        // Open Till Drawer so staff can count the cash
        this.events.OpenTillDrawer(this.terminal.TillDrawerId);

        this.cashUpInfo.TerminalName = this.terminal.Name;
        this.cashUpInfo.CashTotal = 0.0;
        this.cashUpInfo.CardTotal = 0.0;
        this.cashUpInfo.DiscrepancyReason = '';
        this.cashUpInfo.StartDate = new Date();
        this.cashUpInfo.EndDate = new Date();
        this.cashUpInfo.StartTime = dayjs(new Date()).startOf('day').toDate();
        this.cashUpInfo.EndTime = dayjs(new Date()).endOf('day').toDate();
        this.popup.visible = true;
      });
  }

  btnCheckTransactions(e) {
    this.reportingPasswordDialogVisible = true;
  }

  btnOk(e) {
    this.cashUpInfo.StartTime = dayjs(this.cashUpInfo.StartTime).startOf('minute').toDate();
    this.cashUpInfo.EndTime = dayjs(this.cashUpInfo.EndTime).endOf('minute').toDate();
    this.ProcessCloseTerminal(this.cashUpInfo);
  }

  btnCancel(e) {
    this.CloseDlg.emit(false);
    this.popup.visible = false;
  }

  onReportingPasswordDialogHiding() {
    this.reportingPasswordFormData.reportingPassword = '';
  }

  onCashUpFormDataChanged(e) {
    this.isCashUpFormValid = this.cashUpInfoForm.instance.validate().isValid;
  }

  onReportingPasswordFormDataChanged(e) {
    const item = this.reportingPasswordForm.instance.option('items')[0] as any;
    if (item.validationRules.length > 1) {
      item.validationRules = (<any[]>item.validationRules).slice(0, 1);
    }
    this.reportingPasswordForm.instance.option('items', [item]);
  }

  validateStartDate(e): boolean {
    const endDate = this.cashUpInfoForm.instance.getEditor('EndDate')?.option()?.value;
    return !endDate || dayjs(e.value) <= dayjs(endDate);
  }

  validateEndDate(e): boolean {
    const startDate = this.cashUpInfoForm.instance.getEditor('StartDate')?.option()?.value;
    return !startDate || dayjs(e.value) >= dayjs(startDate);
  }

  validateStartTime(e): boolean {
    const startDate = this.cashUpInfoForm.instance.getEditor('StartDate')?.option()?.value;
    const endDate = this.cashUpInfoForm.instance.getEditor('EndDate')?.option()?.value;
    const endTime = this.cashUpInfoForm.instance.getEditor('EndTime')?.option()?.value;
    return !endTime || (dayjs(e.value).isBefore(dayjs(endTime)) || !dayjs(startDate).isSame(endDate, 'day'));
  }

  validateEndTime(e): boolean {
    const startDate = this.cashUpInfoForm.instance.getEditor('StartDate')?.option()?.value;
    const endDate = this.cashUpInfoForm.instance.getEditor('EndDate')?.option()?.value;
    const startTime = this.cashUpInfoForm.instance.getEditor('StartTime')?.option()?.value;
    return !startTime || (dayjs(e.value).isAfter(dayjs(startTime)) || !dayjs(startDate).isSame(endDate, 'day'));
  }

  reportingPasswordBtnOk(e) {
    const item = this.reportingPasswordForm.instance.option('items')[0] as any;

    (<any[]>item.validationRules).push({
      type: 'custom',
      message: 'Reporting Password is incorrect',
      validationCallback: () => {
        return (
          this.reportingPasswordFormData.reportingPassword ===
          this.session.defaultData.defData.customerSettings.ReportingPassword
        );
      },
    });
    this.reportingPasswordForm.instance.option('items', [item]);
    this.reportingPasswordForm.instance.validate();

    if (
      this.reportingPasswordFormData.reportingPassword ===
      this.session.defaultData.defData.customerSettings.ReportingPassword
    ) {
      this.reportingPasswordDialogVisible = false;
      this.salesTransactionListDialogVisible = true;
    }
  }

  reportingPasswordBtnCancel(e) {
    this.reportingPasswordDialogVisible = false;
  }

  OnCloseDiscrepancyDlg(e) {
    this.cashUpInfo = e;
    this.ProcessCloseTerminal(e);
  }

  OnCloseSalesTransactionListDlg(e) {
    this.salesTransactionListDialogVisible = false;
  }

  ProcessCloseTerminal(info: CashUpInfo) {
    this.cashUpInfo = info;

    // Tell any HWC to send TMax Session Counts to server
    this.events.SaveTMaxSessionCounts();

    // Tell API we are closing till
    this.terminalService
      .CloseTerminal(this.terminal, info)
      .pipe(take(1))
      .subscribe((r) => {
        if (r.Status < 10) {
          this.CloseDlg.emit(true);
          this.popup.visible = false;

          this.session.selectEmployee(-1, null).subscribe((r) => {
            this.router.navigate([r.Msg]);
          });
        } else {
          // Ask for discrepancy reason
          this.dlgDiscrepancyReason.show(r);
        }
      });
  }

  onShown(e) {
    this.cashUpDialogVisible = true;
  }

  onHidden(e) {
    this.cashUpDialogVisible = false;
  }
}
